import React from 'react';

export default class FactionButtons extends React.Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this)
  }
  handleChange = (event) => {
    this.props.onChange(event.target.value)
  }

  render() {
    return (
      <div className="faction-buttons">
        <span className='option-title'>FACTION</span>
        <input type="radio" value="1" id="1" className="sigma" name="faction" onChange={this.props.onChange} />
        <label htmlFor="1">Σ</label>
        <input type="radio" value="2" id="2" className="omega" name="faction" onChange={this.props.onChange} />
        <label htmlFor="2">Ω</label>
        <input type="radio" value="3" id="3" className="lambda" name="faction" onChange={this.props.onChange} />
        <label htmlFor="3">Λ</label>
        <input type="radio" value="4" id="4" className="mu" name="faction" onChange={this.props.onChange} />
        <label htmlFor="4">Μ</label>
        <input type="radio" value="5" id="5" className="nu" name="faction" onChange={this.props.onChange} />
        <label htmlFor="5">Ν</label>
        <input type="radio" value="6" id="6" className="chi" name="faction" onChange={this.props.onChange} />
        <label htmlFor="6">Χ</label>
      </div>
    );
  }
}